import React from 'react';
import { DealsTable } from './DealsTable/DealsTable';

export const MyDeals: React.FC = (): JSX.Element => {
  return (
    <div className="deals">
      <DealsTable />
    </div>
  );
};
